import thunkMiddleware from "redux-thunk";
import AdministratorInteractor from "../../domain/interactors/AdministratorInteractor";
import ArchiveDocumentInteractor from "../../domain/interactors/ArchiveDocumentInteractor";
import RequestorInteractor from "../../domain/interactors/RequestorInteractor";
import SessionInteractor from "../../domain/interactors/SessionInteractor";
import SignatoryInteractor from "../../domain/interactors/SignatoryInteractor";
import rootReducer from "./reducers";

import { applyMiddleware, compose, createStore } from "redux";

import APICampaignRepository from "../../data-amazon_api_gateway/APICampaignRepository";
import MockCampaignRepository from "../../data-mock/MockCampaignRepository";
import CampaignRepository from "../../domain/data/CampaignRepository";

import MockPermissionRepository from "../../data-mock/MockPermissionRepository";
import PermissionRepository from "../../domain/data/PermissionRepository";

import MockPermissionTypeRepository from "../../data-mock/MockPermissionTypeRepository";
import PermissionTypeRepository from "../../domain/data/PermissionTypeRepository";

//import SignatoryRepository from '../../domain/data/SignatoryRepository';
//import APISignatoryRepository from '../../data-amazon_api_gateway/APISignatoryRepository';
//import MockSignatoryRepository from '../../data-mock/MockSignatoryRepository';

import MockRoleRepository from "../../data-mock/MockRoleRepository";
import RoleRepository from "../../domain/data/RoleRepository";

import APIPackageRepository from "../../data-amazon_api_gateway/APIPackageRepository";
import MockPackageRepository from "../../data-mock/MockPackageRepository";
import PackageRepository from "../../domain/data/PackageRepository";

import APIExternalSchoolRepository from "../../data-clever/APIExternalSchoolIntegration";
import MockExternalSchoolRepository from "../../data-mock/MockExternalSchoolIntegration";
import ExternalSchoolRepository from "../../domain/data/ExternalSchoolIntegration";

import APIDocumentTemplateRepository from "../../data-amazon_api_gateway/APIDocumentTemplateRepository";
import MockDocumentTemplateRepository from "../../data-mock/MockDocumentTemplateRepository";
import DocumentTemplateRepository from "../../domain/data/DocumentTemplateRepository";

import APISignatoryGroupRepository from "../../data-amazon_api_gateway/APISignatoryGroupRepository";
import MockSignatoryGroupRepository from "../../data-mock/MockSignatoryGroupRepository";
import SignatoryGroupRepository from "../../domain/data/SignatoryGroupRepository";

import APISignatoryRepository from "../../data-amazon_api_gateway/APISignatoryRepository";
import MockSignatoryRepository from "../../data-mock/MockSignatoryRepository";
import SignatoryRepository from "../../domain/data/SignatoryRepository";

import APIDocumentRepository from "../../data-amazon_api_gateway/APIDocumentRepository";
import MockDocumentRepository from "../../data-mock/MockDocumentRepository";
import DocumentRepository from "../../domain/data/DocumentRepository";

import APIMessageRepository from "../../data-amazon_api_gateway/APIMessageRepository";
import MessageRepository from "../../domain/data/MessageRepository";

import APIUserRepository from "../../data-amazon_api_gateway/APIUserRepository";
import MockUserRepository from "../../data-mock/MockUserRepository";
import UserRepository from "../../domain/data/UserRepository";

import APIOrganizationRepository from "../../data-amazon_api_gateway/APIOrganizationRepository";
import MockOrganizationRepository from "../../data-mock/MockOrganizationRepository";
import OrganizationRepository from "../../domain/data/OrganizationRepository";

import APIConfigurationRepository from "../../data-amazon_api_gateway/APIConfigurationRepository";
import MockConfigurataionRepository from "../../data-mock/MockConfigurataionRepository";
import ConfigurationRepository from "../../domain/data/ConfigurationRepository";

import APIChartRepository from "../../data-amazon_api_gateway/APIChartRepository";
import MockChartRepository from "../../data-mock/MockChartRepository";
import ChartRepository from "../../domain/data/ChartRepository";

import APIChatRepository from "../../data-amazon_api_gateway/APIChatRepository";
import ChatRepository from "../../domain/data/ChatRepository";

import APIPaymentRepository from "../../data-amazon_api_gateway/APIPaymentRepository";
import PaymentRepository from "../../domain/data/PaymentRepository";

import APISelectRoutingRepository from "../../data-amazon_api_gateway/APISelectRoutingRepository";
import SelectRoutingRepository from "../../domain/data/SelectRoutingRepository";

import APIPostgisRepository from "../../data-postgis/APIPostgisRepository";
import PostgisRepository from "../../domain/data/PostgisRepository";

import APIArchiveDocumentRepository from "../../data-amazon_api_gateway/APIArchiveDocumentRepository";
import MockArchiveDocumentRepository from "../../data-mock/MockArchiveDocumentRepository";
import ArchiveDocumentRepository from "../../domain/data/ArchiveDocumentRepository";

export enum DataImplementation {
  AMAZON_API_GATEWAY,
  MOCK,
}

export enum ExternalSchoolIntegration {
  CLEVER,
  MOCK,
}

export default function configureStore(
  dataImplementation: DataImplementation = DataImplementation.AMAZON_API_GATEWAY,
  externalSchoolIntegration: ExternalSchoolIntegration = ExternalSchoolIntegration.CLEVER
) {
  let campaignRepository: CampaignRepository;
  let documentRepository: DocumentRepository;
  let documentTemplateRepository: DocumentTemplateRepository;
  let organizationRepository: OrganizationRepository;
  let packageRepository: PackageRepository;
  let permissionRepository: PermissionRepository;
  let permissionTypeRepository: PermissionTypeRepository;
  let roleRepository: RoleRepository;
  //let signatoryRepository: SignatoryRepository;
  let userRepository: UserRepository;
  let signatoryGroupRepository: SignatoryGroupRepository;
  let signatoryRepository: SignatoryRepository;
  let messageRepository: MessageRepository;
  let externalSchoolRepository: ExternalSchoolRepository;
  let configurationRepository: ConfigurationRepository;
  let chartRepository: ChartRepository;
  let chatRepository: ChatRepository;
  let paymentRepository: PaymentRepository;
  let selectRoutingRepository: SelectRoutingRepository;
  let postgisRepository: PostgisRepository;
  let archiveDocumentRepository: ArchiveDocumentRepository;
  
  switch (dataImplementation) {
    case DataImplementation.AMAZON_API_GATEWAY: {
      campaignRepository = new APICampaignRepository();
      documentRepository = new APIDocumentRepository();
      documentTemplateRepository = new APIDocumentTemplateRepository();
      organizationRepository = new APIOrganizationRepository();
      packageRepository = new APIPackageRepository();
      permissionRepository = new MockPermissionRepository();
      permissionTypeRepository = new MockPermissionTypeRepository();
      roleRepository = new MockRoleRepository();
      signatoryRepository = new APISignatoryRepository();
      userRepository = new APIUserRepository();
      signatoryGroupRepository = new APISignatoryGroupRepository();
      messageRepository = new APIMessageRepository();
      configurationRepository = new APIConfigurationRepository();
      chartRepository = new APIChartRepository();
      chatRepository = new APIChatRepository();
      paymentRepository = new APIPaymentRepository();
      selectRoutingRepository = new APISelectRoutingRepository();
      postgisRepository = new APIPostgisRepository();
      archiveDocumentRepository = new APIArchiveDocumentRepository();
      break;
    }
    case DataImplementation.MOCK: {
      campaignRepository = new MockCampaignRepository();
      //campaignRepository = new APICampaignRepository();
      documentRepository = new MockDocumentRepository();
      documentTemplateRepository = new MockDocumentTemplateRepository();
      //organizationRepository = new APIOrganizationRepository();
      organizationRepository = new MockOrganizationRepository();
      packageRepository = new MockPackageRepository();
      permissionRepository = new MockPermissionRepository();
      permissionTypeRepository = new MockPermissionTypeRepository();
      roleRepository = new MockRoleRepository();
      signatoryRepository = new MockSignatoryRepository();
      userRepository = new MockUserRepository();
      signatoryGroupRepository = new MockSignatoryGroupRepository();
      messageRepository = new APIMessageRepository();
      configurationRepository = new MockConfigurataionRepository();
      chartRepository = new MockChartRepository();
      chatRepository = new APIChatRepository();
      paymentRepository = new APIPaymentRepository();
      selectRoutingRepository = new APISelectRoutingRepository();
      postgisRepository = new APIPostgisRepository();
      archiveDocumentRepository = new MockArchiveDocumentRepository();
      break;
    }
  }
  switch (externalSchoolIntegration) {
    case ExternalSchoolIntegration.CLEVER: {
      externalSchoolRepository = new APIExternalSchoolRepository();
      break;
    }
    case ExternalSchoolIntegration.MOCK: {
      externalSchoolRepository = new MockExternalSchoolRepository();
      break;
    }
  }
  const administratorInteractor = new AdministratorInteractor(
    organizationRepository,
    permissionRepository,
    permissionTypeRepository,
    roleRepository,
    userRepository,
    configurationRepository,
    postgisRepository
  );
  const requestorInteractor = new RequestorInteractor(
    campaignRepository,
    documentRepository,
    documentTemplateRepository,
    packageRepository,
    selectRoutingRepository,
    signatoryGroupRepository,
    messageRepository,
    externalSchoolRepository,
    chartRepository,
    postgisRepository
  );
  const sessionInteractor = new SessionInteractor(
    userRepository, 
    signatoryRepository);

  const archiveDocumentInteractor = new ArchiveDocumentInteractor(
    archiveDocumentRepository
  );

  const signatoryInteractor = new SignatoryInteractor(
    documentRepository,
    documentTemplateRepository,
    signatoryRepository,
    campaignRepository,
    chatRepository,
    paymentRepository,
  );

  const middlewares = [
    thunkMiddleware.withExtraArgument({
      administratorInteractor,
      archiveDocumentInteractor,
      requestorInteractor,
      sessionInteractor,
      signatoryInteractor,
    }),
  ];
  const middlewareEnhancer = applyMiddleware(...middlewares);
  const enhancers = [middlewareEnhancer];
  const composeEnhancers =
    (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const composedEnhancers: any = composeEnhancers(...enhancers);
  return createStore(rootReducer, composedEnhancers);
}
